import styled from 'styled-components';

/**
 * Wrapper per le pagine del pannello Founder (catalog).
 * Tema: oro — sfondo caldo scuro, striscia superiore dorata.
 */
const FounderWrapper = styled.div`
  height: 100%;
  min-height: calc(100vh - 70px);
  width: 100%;
  overflow-y: auto;
  background-color: rgb(24, 23, 18);
  border-top: 3px solid gold;
`;

export default FounderWrapper;
